module.exports = __webpack_public_path__ + "img/stitlew.6b249295.png";